module.exports = __webpack_public_path__ + "img/manage-carousel.9cb588c5.png";